// extracted by mini-css-extract-plugin
export default {"container":"PromptImageEditToolbar_container__jMAoB"};